/**
 * OcrSourceReviewModal — 문제 v2 상세에서 「이 문제를 만든 OCR 문제」의 검수 모달을 그 자리에 띄운다.
 *
 * 머리의 「OCR 등록」 배지가 연다(오너 지시 2026-10-02 「페이지 이동 말고 모달만」). 번호 두 칸은 문제 상세의
 * `ocr_project_id`·`ocr_prob_id`(회신 docs/problem-hub-v2/BE-20261002-reply-problem-ocr-origin.md).
 * 모달은 OCR 화면의 것을 **그대로** 쓴다(「어떤 경로든 같은 기능·같은 모달」, 2026-09-05) — 다른 점은 둘뿐이다:
 *   ① 한 문제만 본다(singleProblem) — 이전·다음·목록 탭이 없다(오너 지시 「다음·이전 필요 없음」).
 *   ② 프로젝트 화면이 맡던 버튼(이 페이지 다시 OCR · 전체 다시 분석 · 전체 승인)은 그 콜백을 안 넘겨 빠진다.
 *
 * 종료된 OCR 프로젝트는 읽기 전용이다 — 서버도 수정·삭제를 423 으로 막는다(회신 §3). 모달은 그 여부를 모르므로
 * 프로젝트 상세를 한 번 읽어 넘긴다. **읽기 전까지는 읽기 전용으로 둔다** — 열어 둔 편집이 저장에서 423 을 맞는 것보다
 * 잠깐 잠겨 있다 풀리는 편이 낫다. 프로젝트를 못 읽으면 잠긴 채로 본다(보기는 문제 상세만으로 된다).
 * 이름·공통 키워드·기본 지시도 같은 응답에서 꺼낸다 — OCR 화면의 패널(ProjectDetailPanel)이 넘기는 것과 같은 값이다.
 */
import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import OcrReviewModal from '../OcrHub/OcrReviewModal';
import { getProjectDetail } from '../OcrHub/ocrApi';

// 넘길 목록이 없다. 매 렌더 새 배열이면 모달 안에서 목록을 보는 계산이 헛돈다 — 하나를 붙박아 둔다
const NO_ITEMS = [];

export default function OcrSourceReviewModal({ projectId, ocrProbId, onClose }) {
  const { getAccessToken } = useAuth();
  const [project, setProject] = useState(null);

  useEffect(() => {
    let alive = true;
    getProjectDetail(projectId, getAccessToken)
      .then((d) => { if (alive && d) setProject(d); })
      .catch(() => { /* 머리 주석 — 잠긴 채로 본다 */ });
    return () => { alive = false; };
  }, [projectId, getAccessToken]);

  return (
    <OcrReviewModal
      isOpen
      singleProblem
      problemId={ocrProbId}
      projectId={projectId}
      items={NO_ITEMS}
      closed={project ? (project.status ?? 0) >= 500 : true}
      projectName={project?.name || ''}
      projectKeywords={project?.keywords}
      projectDefaultPrompt={project?.default_prompt || ''}
      onClose={onClose}
    />
  );
}
